var exports = {
  "r": "GitHubAvatar__FSJe3J",
};

module.exports = exports;
